// extracted by css-extract-rspack-plugin
export default {"root":"edit__root___KYg0l"};